import React from 'react';
import {
  ExtractIcon, Regions,
} from '../Styled/Buttons/icons';
import meta from '../../const/meta';
import SubPage from '../MaterialUI/subpage';

const items = [
  {
    url: meta.cat.lands.frontend,
    title: 'Довідник земельних ділянок',
    icon: ExtractIcon,
    section: 'contract',
    desc: 'Виписики з держ. казначейства',
  },
  {
    url: meta.cat.specialpurpose.frontend,
    title: 'Довідник призначень земельних ділянок',
    icon: Regions,
    section: 'contract',
    desc: 'Довідник призначень земельних ділянок',
  },
  {
    url: meta.cat.landcategories.frontend,
    icon: Regions,
    onlyForAdmins: true,
    section: 'subscription',
    desc: 'Категорія земель',
  },
  {
    url: meta.cat.landcertificate.frontend,
    icon: Regions,
    onlyForAdmins: true,
    section: 'contract',
    title: 'Сертифікати на право на земельну частку (пай)',
    desc: 'Сертифікати на право на земельну частку (пай)',
  },
  {
    url: meta.cat.sessiondecision.frontend,
    icon: Regions,
    onlyForAdmins: true,
    section: 'contract',
    desc: 'Рішення сесії',
  },
  {
    url: '/landSessionXml/',
    icon: Regions,
    onlyForAdmins: true,
    section: 'contract',
    desc: 'Вивантаження до файлу XML Рішеннь сесії про виділення земельних ділянок у натурі (на місцевості) власникам земельних часток (паїв)',
    title: 'Вивантаження до файлу XML Рішеннь сесії',
  },
  {
    url: '/cat/specialpurpose/',
    icon: Regions,
    onlyForAdmins: true,
    section: 'contract',
    desc: 'Класифікація видів цільового призначення земель',
    title: 'Класифікація видів цільового призначення земель',
  },
  {
    url: '/cat/percentvalue/',
    icon: Regions,
    onlyForAdmins: true,
    section: 'contract',
    desc: 'Ставки земельного податку',
    title: 'Ставки земельного податку',
  },
  {
    url: '/landTaxCalculation/',
    icon: Regions,
    onlyForAdmins: true,
    section: 'contract',
    desc: 'Розрахунок податку на землю',
    title: 'Розрахунок податку на землю',
  },
];
function LandsPage() {
  return <SubPage pageTitle="Облік земельних ділянок" items={items} />;
}

export default LandsPage;
